import { RouteComponentProps } from "@reach/router"
import { FullPageLoader } from "@shared/primitive-components"
import { UUID } from "io-ts-types/lib/UUID"
import { invariant } from "@shared/utils/checks/invariant"
import { useAuth } from "../../../../contexts/AuthProvider"
import { useViewer } from "../../../auth/ui/ViewerProvider"
import { useFindPolicy } from "../../api/useFindPolicy"
import { PolicyView } from "./components/PolicyView"
import { useEnsureOwnerId } from "../../../auth/api/useEnsureOwnerId"

export const Policy = ({ id }: RouteComponentProps<{ id: UUID }>) => {
  invariant(id, `an id must be passed to the policy page`)
  useEnsureOwnerId()

  const { viewer } = useViewer()
  const auth = useAuth()

  const [res] = useFindPolicy({
    user: { type: auth.getAuthType(), viewerId: viewer },
    id,
  })

  if (res.result === undefined) return <FullPageLoader />
  if (res.result.tag === `err`) return <span>error ...</span>

  return <PolicyView policy={res.result.data} />
}
